import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Input, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, FormGroup, Validators, UntypedFormControl } from '@angular/forms';
import { Location } from '@angular/common'
import { InventoryService } from '../../services/inventory.service';
import { OrdersService } from '../../services/orders.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { PrintService } from '../../services/print.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { forkJoin, merge, fromEvent, interval, Subscription, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith, tap, delay, takeUntil } from 'rxjs/operators';


import { DatePipe } from '@angular/common';

@Component({
	selector: 'app-item-query',
	templateUrl: './item-query.component.html',
	styleUrls: ['./item-query.component.scss']
})
export class ItemQueryComponent implements OnInit, OnDestroy {

	@Input() stockid;
	@ViewChild('itemsearch') customersearch: ElementRef;
	@ViewChild('itemdetailsModal') itemDetailsREf: ElementRef;
	itemSearchControl = new UntypedFormControl('');
	categoryControl = new UntypedFormControl('');
	productLineControl = new UntypedFormControl('');
	searching = false;
	searchfield = [];
	items: any = [];
	config: any;
	allitems: any = [];
	header: any = [];
	results: any = [];
	inventorysearching: any;
	itemsearchsubscription: any;
	categories: any = false;
	productlines: any = false;
	user: any = false;
	item_details: any = false;
	include_disabled = new UntypedFormControl(false);
	locationControl = new UntypedFormControl([]);
	locationsList: any[] = [];
	exportingReport = false;
	private readonly destroy$ = new Subject<void>();

	@ViewChild('print_table', { static: false }) printTable: ElementRef<HTMLElement>;

	headercolumns: any = [
		'stockid',
		'lineid',
		'description',
		'qoh',
		'cost',
		'price',
		'supplierno',
	];

	selectedimage = '';

	color: any = 'blue'
	dataSource: MatTableDataSource < any > ;
	private sort: MatSort;
	running: any = false;
	itemdetails: any = false;
	editing = {
		settings: false,
		extra: false,
		descriptions: false,
		attributes: false,
		images: false,
		prices: false,
		stock: false,
		purchasing: false,
	}

	isEditingAvgCost = false;
	editingAvgCostValue: number;

	dataObs: Observable < any > ;
	items_per_page = [25, 50, 100, 500];
	pagesizedefault = 100;
	salestypes: any = false;
	loadingitem: any = false;
	userlocation: any = false;
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	@ViewChild(MatSort) set matSort(ms: MatSort) {
		this.sort = ms;
		this.setDataSourceAttributes();
	}

	@ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {

		this.paginator = mp;
		this.setDataSourceAttributes();
	}

	setDataSourceAttributes() {
		this.dataSource.paginator = this.paginator;
	}

	constructor(private datePipe: DatePipe, private modalService: NgbModal, private globalsService: GlobalsService, private _changeDetectorRef: ChangeDetectorRef, private route: ActivatedRoute, private formBuilder: UntypedFormBuilder, public router: Router, private location: Location, public inventoryService: InventoryService, public orderService: OrdersService, private globalSearchService: GlobalSearchService, private printService: PrintService) {
		this.inventoryService.getItemCategories().subscribe((r:any) => {
			this.categories = r
		})
		this.inventoryService.getItemProductlines().subscribe((r:any) => {
			this.productlines = r;
		})

		this.globalSearchService.userData.subscribe((r:any) => {
			this.user = r;
			this.userlocation = r.user.defaultlocation.loccode;
		})

		this.globalSearchService.configsubscription.subscribe((r:any) => {
			this.config = r;
		})

		this.globalSearchService.locations.pipe(takeUntil(this.destroy$)).subscribe((locs: any) => {
			this.locationsList = Array.isArray(locs) ? locs : [];
			this.ensureLocationSelectionDefaults();
		});

		this.locationControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((v: string[] | null) => {
			if ((!v || v.length === 0) && this.locationsList?.length) {
				this.locationControl.setValue(this.locationsList.map((l) => l.loccode), { emitEvent: false });
			}
		});

		this.color = this.globalSearchService.getColor();

		this.globalSearchService.all_system_types.subscribe((r: any) => {
			if (!r) {
				this.globalsService.getTypes().subscribe((results: any) => {
					this.salestypes = results.salestypes;
				});
			} else {
				this.salestypes = r.salestypes;
			}
		});


		// forkJoin({
		// 	categories: this.inventoryService.getItemCategories(),
		// 	productlines: this.inventoryService.getItemProductlines(),
		// 	user: this.globalSearchService.userData,
		// 	config: this.globalSearchService.configsubscription
		// }).subscribe(results => {
		// 	this.categories = results.categories;
		// 	this.productlines = results.productlines;
		// 	this.user = results.user;
		// 	this.config = results.config;
		// 	// After the initial data is fetched, handle the color and salestypes logic
		// 	this.color = this.globalSearchService.getColor();

		// 	this.globalSearchService.all_system_types.subscribe((r: any) => {
		// 		if (!r) {
		// 			this.globalsService.getTypes().subscribe((results: any) => {
		// 				this.salestypes = results.salestypes;
		// 			});
		// 		} else {
		// 			this.salestypes = r.salestypes;
		// 		}
		// 	});
		// });

	}

	ngOnInit(): void {
		this.searching = false;
		this.setPagination([])
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
		if (this.inventorysearching) {
			this.inventorysearching.unsubscribe();
		}
	}

	private normalizeLookupItems(items: any): any[] {
		if (Array.isArray(items)) {
			return items;
		}
		if (items && typeof items === 'object') {
			return Object.values(items);
		}
		return [];
	}

	ensureLocationSelectionDefaults(): void {
		if (!this.locationsList?.length) {
			return;
		}
		const cur = this.locationControl.value as string[] | null;
		if (!cur?.length) {
			const all = this.locationsList.map((l) => l.loccode);
			this.locationControl.setValue(all, { emitEvent: false });
		}
	}

	getSelectedLocationMeta(): any[] {
		const selected = this.locationControl.value as string[] | null;
		if (!selected?.length || !this.locationsList?.length) {
			return [];
		}
		const sel = new Set(selected.map((c) => String(c)));
		return this.locationsList
			.filter((l) => sel.has(String(l.loccode)))
			.sort((a, b) => String(a.loccode).localeCompare(String(b.loccode)));
	}

	getQohAtLocation(item: any, loccode: string): number {
		if (!item?.qoh || !Array.isArray(item.qoh)) {
			return 0;
		}
		const code = String(loccode);
		return item.qoh
			.filter((row: any) => String(row.loccode) === code)
			.reduce((sum: number, row: any) => sum + parseFloat(row.quantity ?? 0), 0);
	}

	getTotalSelectedQoh(item: any): number {
		const meta = this.getSelectedLocationMeta();
		if (!meta.length) {
			return 0;
		}
		return meta.reduce((t, loc) => t + this.getQohAtLocation(item, loc.loccode), 0);
	}

	/** Per-location quantity tone (badges in the grid). */
	getQohCellClass(qty: number | string): string {
		const q = typeof qty === 'string' ? parseFloat(qty) : Number(qty);
		if (Number.isNaN(q)) {
			return 'iq-qoh iq-qoh--zero';
		}
		if (q < 0) {
			return 'iq-qoh iq-qoh--neg';
		}
		if (q === 0) {
			return 'iq-qoh iq-qoh--zero';
		}
		if (q < 4) {
			return 'iq-qoh iq-qoh--low';
		}
		return 'iq-qoh iq-qoh--ok';
	}

	/** Total across selected locations — uses a higher “low stock” bar when many sites are selected. */
	getQohTotalClass(item: any): string {
		const n = this.getTotalSelectedQoh(item);
		const nLocs = Math.max(1, this.getSelectedLocationMeta().length);
		const lowThreshold = Math.max(4, nLocs * 2);
		if (Number.isNaN(n)) {
			return 'iq-qoh iq-qoh--zero';
		}
		if (n < 0) {
			return 'iq-qoh iq-qoh--neg';
		}
		if (n === 0) {
			return 'iq-qoh iq-qoh--zero';
		}
		if (n < lowThreshold) {
			return 'iq-qoh iq-qoh--low';
		}
		return 'iq-qoh iq-qoh--ok';
	}

	exportReportTitle(): string {
		const company = this.globalSearchService.company.getValue();
		const name = company?.coyname || company?.companyname || company?.name || '';
		const base = name ? `${name} — ` : '';
		return `${base}Inventory query`;
	}

	exportReportSubtitle(): string {
		const parts: string[] = [];
		const term = (this.itemSearchControl.value || '').toString().trim();
		if (term) {
			parts.push(`Search: ${term}`);
		}
		const locs = this.getSelectedLocationMeta().map((l) => l.locationname || l.loccode);
		if (locs.length) {
			parts.push(`Locations: ${locs.join(', ')}`);
		}
		parts.push(`Generated ${this.datePipe.transform(new Date(), 'medium') || ''}`);
		return parts.join(' · ');
	}

	exportFilename(stem: string): string {
		const client = this.config?.env?.client ?? 'export';
		const stamp = this.datePipe.transform(new Date(), 'yyyy-MM-dd_HHmm') ?? String(Date.now());
		return `${client}_${stem}_${stamp}`;
	}

	exportPdf(): void {
		if (!this.printTable?.nativeElement || !this.allitems?.length) {
			return;
		}
		this.exportingReport = true;
		const encoded = this.globalSearchService.base64encode(this.printTable.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: this.exportFilename('inventory_query'),
			title: `${this.exportReportTitle()} — ${this.exportReportSubtitle()}`,
		};
		this.printService.pdf(data).subscribe({
			next: (result: any) => {
				this.globalSearchService.downloadPdf(result.content, data.filename);
				this.exportingReport = false;
			},
			error: () => {
				this.exportingReport = false;
			},
		});
	}

	exportXls(): void {
		if (!this.printTable?.nativeElement || !this.allitems?.length) {
			return;
		}
		this.exportingReport = true;
		const encoded = this.globalSearchService.base64encode(this.printTable.nativeElement.innerHTML);
		const data = {
			content: encoded,
			filename: this.exportFilename('inventory_query'),
			title: `${this.exportReportTitle()} — ${this.exportReportSubtitle()}`,
		};
		this.printService.xls(data).subscribe({
			next: (result: any) => {
				this.globalSearchService.downloadXls(result.content, data.filename);
				this.exportingReport = false;
			},
			error: () => {
				this.exportingReport = false;
			},
		});
	}

	searchItems() {
		this.searching = true;

		if (this.inventorysearching) {
			this.inventorysearching.unsubscribe()
		}

		const search = {
			stockid: this.itemSearchControl.value,
			category: this.categoryControl.value,
			productlines: this.productLineControl.value,
			discontinued: this.include_disabled.value,
			price: 'default',
			itemquery: true,
			client: this.config?.env?.client,
			salesman: this.user?.user?.salesman
		}

		//leaving off until aa is on inventory && hairlines wanted it to be all shrewsbury
		// if(this.config.env.package == 'beauty'){
		// 	search['warehouse'] = this.user.user.defaultlocation.loccode;
		// }

		this.inventorysearching = this.inventoryService.lookup(search).subscribe((items: any) => {
			const list = this.normalizeLookupItems(items);
			this.allitems = list;
			if (list.length === 1) {
				this.loadItem(list[0].stockid)
			} else {
				this.itemdetails = false;
			}
			this.searching = false;
			this.setPagination(list);
		});
	}


	loadItem(stockid: any) {
		this.loadingitem = true;
		this.inventoryService.loadItem(stockid).subscribe((results: any) => {
			this.itemdetails = results;
			this.loadingitem = false;
		});
	}
	formatDate(date: string): string {
		return this.datePipe.transform(date, 'shortDate');
	}
	getFilteredItemStock() {
		// Initialize an array to hold the final filtered items
		const filteredItems = [];

		// Loop through all warehouses to ensure they are included
		this.itemdetails.itemstock.forEach(item => {
			const bins = this.itemdetails.bins[item.loccode];
			let includeItem = false;

			if (bins) {
				// Calculate bin quantities and check conditions
				const binQuantities = bins.map(loc => Number(loc.quantity));
				const hasPositiveAndNegative = binQuantities.some(q => q > 0) && binQuantities.some(q => q < 0);
				let defaultBin = bins.find(bin => bin.defaultbin === '1') || bins.find(bin => Number(bin.quantity) === 0);

				// If conditions are not met, set item quantity to zero and keep only the default or empty bin
				if (!hasPositiveAndNegative) {
					includeItem = true;
				} else {
					// Set item quantity to zero
					item.quantity = '0';
					includeItem = true; // Ensure the item is still included
					// If there's no valid default or empty bin, select the first available bin
					if (!defaultBin) {
						defaultBin = bins[0];
					}
				}

				// Assign the default or empty bin and filter out other bins
				if (defaultBin) {
					item.defaultBin = defaultBin.bin;
					item.quantity = Number(defaultBin.quantity) === 0 ? '0' : item.quantity;
				}

				// Clear the bins array and include only the selected bin in the final item
				this.itemdetails.bins[item.loccode] = [defaultBin];
			} else {
				// Include the item if there are no bins
				includeItem = true;
			}

			// Include the item in the final results if necessary
			if (includeItem) {
				filteredItems.push(item);
			}
		});

		return filteredItems;
	}

	getPriceForKey(key: string): number {
		if (this.itemdetails.item.special) {
			if (this.itemdetails.item.special.prices) {
				if (this.itemdetails.item.special.prices.hasOwnProperty(key)) {
					const price = this.itemdetails.item.special.prices[key];

					if (price) {
						return this.financial(price);
					}
				}
			}
		}
		return 0;
	}

	financial(x) {

		if (Number.isNaN(x)) {
			x = 0
		}

		return parseFloat(Number.parseFloat(x).toFixed(2));
	}

	getGp(price, cost) {
		const priceminuscost = (this.financial(price) - this.financial(cost)) * 100;
		if (this.financial(price) != 0) {
			return (this.financial(priceminuscost / this.financial(price)));
		} else {
			return 0.00;
		}
	}

	getFirstPriceValue(prices: {
		[key: string]: any
	}): any {
		const keys = Object.keys(prices);
		if (keys.length === 0) {
			return 0;
		}
		const firstKey = keys[0];
		return prices[firstKey];
	}

	changeMainImage(image: any) {
		if (this.itemdetails.item) {
			this.itemdetails.item.full_size_image = image.image;
			this.selectedimage = image.file;
		}
	}

	clearForm() {
		this.itemSearchControl.setValue('');
		this.allitems = [];
		this.items = [];
		this.searching = false;
	}

	back(): void {
		this.location.back();
	}

	viewItem(row: any) {
		this.allitems = [];
		this.items = [];
		this.itemSearchControl.setValue('');
		this.router.navigate(['/inventory/view/' + row.stockid])
	}

	setPagination(tableData) {
		this.dataSource = new MatTableDataSource < any > (tableData);
		this._changeDetectorRef.detectChanges();
		this.dataSource.paginator = this.paginator;
		this.dataObs = this.dataSource.connect();
	}

	openModal(content, item) {

		this.item_details = item;
		this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {
			this.item_details = false;
		});
	}


	announceSortChange(input: any) {

	}

	copiedStockId: string | null = null;

	copyToClipboard(stockid: string, event: Event): void {
		event.stopPropagation();
		navigator.clipboard.writeText(stockid).then(() => {
			this.copiedStockId = stockid;
			setTimeout(() => this.copiedStockId = null, 1000);
		});
	}

	toHTML(input): any {
		return new DOMParser().parseFromString(input, 'text/html').documentElement.textContent;
	}

	updateItem(updateditem){
		const stockid = updateditem.item.stockid;
		const newbins = updateditem.bins;

		const up = this.allitems.map((prod)=>{
			if(prod.stockid === stockid){

				let allbins = [];
				Object.keys(newbins).forEach((loccode)=>{
					allbins = [...allbins, ...newbins[loccode]]
				});
				prod.qoh = allbins;
			}
			return prod;
		})

		this.setPagination(up);
		this.allitems = up;
	}

}